import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { RolePermissions } from 'shared/domain';

export const ADMIN_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'components',
    pathMatch: 'full',
  },
  {
    path: 'components',
    title: 'Treetop Components',
    loadComponent: () => import('@treetop/admin/components').then((m) => m.ComponentsPageComponent),
    loadChildren: () => import('@treetop/admin/components').then((m) => m.COMPONENTS_PAGE_ROUTES),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [RolePermissions.viewComponents],
        redirectTo: '/login',
      },
    },
  },
  {
    path: 'statistics',
    title: 'Treetop Statistics',
    loadComponent: () => import('@treetop/admin/statistics').then((m) => m.AdminStatisticsPageComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [RolePermissions.viewAllOrganisationStatistics],
        redirectTo: '/login',
      },
    },
  },
  {
    path: 'administration',
    title: 'Treetop Administration',
    loadComponent: () => import('@treetop/admin/administration').then((m) => m.AdministrationPageComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [RolePermissions.copyGuidelines],
        redirectTo: '/login',
      },
    },
  },
];
